/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit1_DInputs */

const en_sorter_pit1_d = /** @type {(inputs: Sorter_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys made only of digits are stored ahead of every string key in ascending numeric order, and re-serializing cannot override that. Sorting the object with keys b, 10, a, 2 in descending mode returns 2, 10, b, a. The digit keys came out ascending and first, in direct contradiction of the direction you selected. This is a property of the object model, not a bug in the comparison, and no browser based tool can avoid it.`)
};

const ko_sorter_pit1_d = /** @type {(inputs: Sorter_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자만으로 된 키는 모든 문자열 키보다 앞에 오름차순으로 저장되며, 재직렬화로는 이를 되돌릴 수 없습니다. b, 10, a, 2 키를 가진 객체를 내림차순으로 정렬하면 2, 10, b, a가 나옵니다. 숫자 키가 선택한 방향과 정반대로 오름차순으로, 그리고 맨 앞에 나온 것입니다. 이는 비교 로직의 버그가 아니라 객체 모델의 성질이며, 브라우저 기반 도구는 이를 피할 수 없습니다.`)
};

const ja_sorter_pit1_d = /** @type {(inputs: Sorter_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字だけで構成されたキーは、すべての文字列キーより前に昇順で保存され、再シリアライズでは覆せません。b, 10, a, 2 というキーを持つオブジェクトを降順で並べ替えると 2, 10, b, a になります。数値キーが選んだ方向と正反対の昇順で、しかも先頭に出たわけです。これは比較処理のバグではなくオブジェクトモデルの性質で、ブラウザベースのツールは避けられません。`)
};

/**
* | output |
* | --- |
* | "Keys made only of digits are stored ahead of every string key in ascending numeric order, and re-serializing cannot override that. Sorting the object with ke..." |
*
* @param {Sorter_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit1_d = /** @type {((inputs?: Sorter_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit1_d(inputs)
	if (locale === "ko") return ko_sorter_pit1_d(inputs)
	return ja_sorter_pit1_d(inputs)
});